// src/lib/blog/config/defaults.ts

import { siteConfig } from '~/lib/config/site'

/**
 * Default values shared across blog config modules. Extracted from `index.ts`
 * so `authors.ts` / `topics.ts` can depend on it without a circular import
 * back through the barrel.
 */
export const DEFAULTS = {
  AVATAR: '/images/blog/adsights-avatar-default-icon-2048x2048.webp',
  // JPEG, not WebP: this constant is what /blog and every blog hub metadata
  // generator pass into `generateCoreMetadata` as og:image, and
  // LinkedIn-class scrapers don't render WebP social cards. Must stay in
  // lock-step with `siteConfig.defaultImages.blog` (same .jpg sibling,
  // generated by scripts/convert-og-webp-to-jpg.ts). `r3540558230`.
  BLOG_IMAGE: '/images/blog/adsights-digital-marketing-insights-creative-analytics-blog-og-image.jpg',
  AUTHOR_ROLE: 'Contributor',
  AUTHOR_BIO: 'Guest Contributor',
  TOPIC_TITLE: 'General',
  TOPIC_SLUG: 'general',
  TOPIC_DESCRIPTION: 'General insights and articles about digital advertising and marketing.',
  WORDS_PER_MINUTE: 200,
  SITE_URL: siteConfig.url
}
